import { render, staticRenderFns } from "./uf_type_loan.vue?vue&type=template&id=f126b60c&scoped=true"
import script from "./uf_type_loan.vue?vue&type=script&lang=js"
export * from "./uf_type_loan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f126b60c",
  null
  
)

export default component.exports